



























































import { ValidationFunc } from "@/models/Validation";
import dayjs, { ManipulateType} from "dayjs";
import Vue from "vue";

export default Vue.extend({
  props: {
    id: { type: String },
    title: { type: String },
    placeholder: { type: String, default: "ÉÉÉÉ.HH.NN." },
    customStyle: { type: String, default: "" },
    className: { type: String, default: "" },
    value: [Date, String],
    disabled: { type: Boolean },
    showIcon: { type: Boolean, default: true },
    min: { type: [String, Date], default: "1900-01-01" },
    max: { type: [String, Date], default: "2100-12-31" },
    fromToday: { type: Boolean, default: false},
    rules: { type: Array as () => Array<ValidationFunc>, default:() => [(v: Date | string) => true]},
    tabindex: { type: String },
    forceEmptyDisplay: { type: Boolean, default: false },
  },

  mounted(){
    if (this.value){
      this.innerValue = this.parseDate(this.value);
    }

    // A Vuetify a @click:append miatt <button>-ként rendereli a naptár-ikont (VIcon:
    // hasClickListener ? 'button' : tag), így a dátummező KÉT tab-megálló lenne: a beviteli
    // mező és az ikon. Az ikon kikerül a tab-sorrendből (kattintásra változatlanul nyílik).
    const iconBtn = (this.$el as HTMLElement).querySelector<HTMLElement>(".v-input__append-inner button");
    if (iconBtn) iconBtn.tabIndex = -1;
  },

  data: () => {
    const obj: { menu1: boolean; innerValue: string | null; dateFormatted: string | null; isParsing: boolean } = {
      menu1: false,
      innerValue: '',
      dateFormatted: '',
       isParsing: false,
    };

    return obj;
  },

  computed: {
    stringValue() {
      if (!this.value) {
        return null;
      }

      return dayjs(this.value).format("YYYY-MM-DD");
    },
    stringToday() {
      return dayjs(new Date()).format("YYYY-MM-DD");
    },
    minDate() {
      if (this.$props.min instanceof Date) {
        return dayjs(this.$props.min).format("YYYY-MM-DD");
      }
      if (this.$props.min === null) {
        return dayjs("1900-01-01").format("YYYY-MM-DD");
      }
      return this.$props.min;
    },
    maxDate() {
      if (this.$props.max instanceof Date) {
        return dayjs(this.$props.max).format("YYYY-MM-DD");
      }
      if (this.$props.max === null) {
        return dayjs("2100-12-31").format("YYYY-MM-DD");
      }
      return this.$props.max;
    },
  },

  methods: {
    onInput(value: string | null, addoffset = false) {
      if (value) {
        const valid =
          /\d{4}.\d{2}.\d{2}/.test(value)
          || /\d{4}-\d{2}-\d{2}/.test(value)
          || /^\d{8}$/.test(value)
          || /^\d{6}$/.test(value)
          || /^\d{4}$/.test(value);

        if (valid) {
          this.innerValue = this.parseDate(value);

          let min = this.min === null ? "1900-01-01" : this.parseDate(this.min);
          if (this.fromToday && !min){
            min = dayjs(new Date()).format('YYYY-MM-DD');
          }

          let max = this.max === null ? "2100-12-31" : this.parseDate(this.max);
          if (this.fromToday && !max){
            max = dayjs(new Date()).format('YYYY-MM-DD');
          }

          console.log("Min. date:", JSON.parse(JSON.stringify(min)));
          console.log("Max. date:", JSON.parse(JSON.stringify(max)));
          console.log("Date:", JSON.parse(JSON.stringify(this.innerValue)));

          if (
            (!!(min) && (dayjs(this.innerValue).isSame(min) || dayjs(this.innerValue).isAfter(min))) &&
            (!!(max) && (dayjs(this.innerValue).isSame(max) || dayjs(this.innerValue).isBefore(max)))
          ) {
            let ret;
            if (addoffset) {
              const [year, month, day] = this.innerValue?.split('-').map(Number) ?? [1900, 1, 1];
              const local = new Date(year, month - 1, day, 0, 0, 0);
              ret = new Date(local.getTime() - local.getTimezoneOffset() * 60000);
            } else {
              ret = dayjs(this.innerValue).toDate();
            }

            console.log("Returned date object:", JSON.parse(JSON.stringify(ret)));
            this.$emit('input', ret);
          } else {
            this.innerValue = '';
            this.$emit("input", null);
          }
        } else {
          this.innerValue = '';
          this.$emit("input", null);
        }
      } else {
        this.innerValue = '';
        this.$emit("input", null);
      }
    },

    parseDate (date: (string | Date | null) ) {

      if (!date) return null;

      if (date instanceof Date) {
        return dayjs(date).format("YYYY-MM-DD");
      }
      
      const input = date.trim();
      let parsed: dayjs.Dayjs | null = null;

      //Format: YYYYMMDD
      if (/^\d{8}$/.test(input)) {
        parsed = dayjs(input, 'YYYY-MM-DD');
      }
      //Format: YYMMDD
      else if (/^\d{6}$/.test(input)) {
        const year = '20' + input.substring(0, 2);
        const month = input.substring(2, 4);
        const day = input.substring(4, 6);
        
        parsed = dayjs(`${year}-${month}-${day}`, 'YYYY-MM-DD');
      }
      //Format: MMDD (ebben az esetben a jelenlei évet fűzzük hozzá)
      else if (/^\d{4}$/.test(input)) {
        const year = dayjs().year();
        const month = input.substring(0, 2);
        const day = input.substring(2, 4);
        parsed = dayjs(`${year}-${month}-${day}`, 'YYYY-MM-DD');
      }
      //Default
      else {
        parsed = dayjs(date);
      }

      const ret = parsed.format("YYYY-MM-DD");
      return ret;
    },

    setToday() {
      const today = dayjs().format("YYYY-MM-DD");
      if (today){
        this.innerValue = this.parseDate(today);
        this.$emit("input", today);
        this.menu1 = false;        
      }
    },

    clear() {
      this.innerValue = '';
      this.$emit("input", null);
      this.menu1 = false;
    },

    // A mező az egyetlen tab-megálló (a naptár-ikon kikerült a tab-sorrendből), ezért fókuszba
    // kerülve mindjárt le is nyílik a naptár: vagy beírja/felülgépeli a dátumot és Enter, vagy
    // egérrel választ a naptárból. Tab/Enter/Esc bezárja. A :retain-focus="false" miatt a fókusz
    // a mezőben marad, tehát a gépelés nyitott naptárnál is működik.
    onFieldFocus() {
      this.selectAll();
      if (!this.disabled) {
        this.menu1 = true;
      }
    },

    // Ha a fókusz a mezőről a komponensen ÉS a naptár-popupon kívülre megy (pl. Ctrl+Alt+nyilas
    // vagy programozott fókuszmozgatás — ott nincs Tab keydown, ami zárna), a naptár záruljon be.
    // A naptárba kattintás nem zár: olyankor a relatedTarget a popup tartalmában van.
    onFieldBlur(e: FocusEvent) {
      const to = e.relatedTarget as HTMLElement | null;
      if (to) {
        const content = (this.$refs.menu1 as any)?.$refs?.content as HTMLElement | undefined;
        if ((content && content.contains(to)) || (this.$el as HTMLElement).contains(to)) return;
      }
      this.menu1 = false;
    },

    selectAll() {
      this.$nextTick(() => {
        const input = ((this.$refs.textfield as Vue | undefined)?.$el as HTMLElement).querySelector('input');
        if (input) {
          input.select();
        }
      });
    },
  },

  watch: {
    innerValue() {
      if (!(this.innerValue) || this.innerValue == '')  {
        this.dateFormatted = null;
        return;
      }
      this.dateFormatted = this.forceEmptyDisplay ? null : dayjs(this.innerValue).format("YYYY.MM.DD.");
    },

    value() {
      this.innerValue = this.parseDate(this.value);
    }
  },
});
